import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { Button, TextField } from '@tryhackme/thm-ui-components';
import { useState } from 'react';
import { DeleteModal } from 'src/common/delete-modal';
import { useFormContext } from 'src/common/form';
import { StyledElementsContainer, StyledEndNodeField, StyledGridContainer, StyledStartNodeField, StyledSubtitle, StyledSubtitleContainer, StyledToNodeField } from 'src/features/admin/networks/components/connections/connections.styles';
import { StyledCancelIconHeader, StyledConnectionsContainer, StyledDeleteIcon, StyledElementHeader, StyledElementTitle, StyledFontAwesomeIcon } from '../../networks.styles';
import type { NetworkConnectionsProps } from '../../networks.types';
export const NetworkConnections = ({
  fields,
  append,
  remove
}: NetworkConnectionsProps) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const {
    register
  } = useFormContext();
  return <StyledConnectionsContainer data-testid="connections" data-sentry-element="StyledConnectionsContainer" data-sentry-component="NetworkConnections" data-sentry-source-file="connections.tsx">
      <StyledSubtitleContainer data-sentry-element="StyledSubtitleContainer" data-sentry-source-file="connections.tsx">
        <StyledSubtitle data-sentry-element="StyledSubtitle" data-sentry-source-file="connections.tsx">Connections</StyledSubtitle>
        <Button variant="solid" color="add" onClick={() => append({
        from: 0,
        to: 0
      })} data-testid="addConnectionBottom" data-sentry-element="Button" data-sentry-source-file="connections.tsx">
          <StyledFontAwesomeIcon icon={faPlus} data-sentry-element="StyledFontAwesomeIcon" data-sentry-source-file="connections.tsx" />
          Add Connection
        </Button>
      </StyledSubtitleContainer>
      {fields?.map((item, index) => <StyledElementsContainer key={item.id}>
          <StyledCancelIconHeader>
            <Button variant="text" color="secondary" aria-label="Delete connection" onClick={() => {
          setActiveIndex(index);
          setDeleteModalOpen(true);
        }}>
              <StyledDeleteIcon icon={faXmark} />
            </Button>
          </StyledCancelIconHeader>
          <StyledElementHeader>
            <StyledElementTitle>{`Connection ${index + 1}`}</StyledElementTitle>
          </StyledElementHeader>
          <StyledGridContainer>
            <StyledStartNodeField>
              <TextField {...register(`connections.${index}.from`)} variant="input" label="Node" id={`connections.${index}.from`} />
            </StyledStartNodeField>
            <StyledToNodeField>to</StyledToNodeField>
            <StyledEndNodeField>
              <TextField {...register(`connections.${index}.to`)} variant="input" label="Node" id={`connections.${index}.to`} />
            </StyledEndNodeField>
          </StyledGridContainer>
        </StyledElementsContainer>)}
      <DeleteModal open={deleteModalOpen} onOpenChange={setDeleteModalOpen} modalTitleText="Delete Connection" modalBodyText="Are you sure you want to delete this connection?" activeIndex={activeIndex} handleDeleteAction={(activeInd: number) => remove(activeInd)} data-sentry-element="DeleteModal" data-sentry-source-file="connections.tsx" />
    </StyledConnectionsContainer>;
};